import { ReactElement, useEffect } from 'react';

import { QueryClientProvider } from '@tanstack/react-query';
import 'antd/dist/reset.css';
import { PostHogProvider } from 'posthog-js/react';
import { HelmetProvider } from 'react-helmet-async';

import '@/styles/custom-styles.scss';
import '@/styles/reset.scss';

import { queryClient } from './configs/queryClient';
import AppRouter from './router';

import { posthog } from '@/shared/configs/posthog';
import { trackMetaPixelPageView } from '@/shared/utils/metaPixel.utils';

const MetaPixelPageView = (): null => {
	useEffect(() => {
		trackMetaPixelPageView();
	}, []);

	return null;
};

function App(): ReactElement {
	return (
		<div className="app">
			<MetaPixelPageView />
			<PostHogProvider client={posthog}>
				<HelmetProvider>
					<QueryClientProvider client={queryClient}>
						<AppRouter />
					</QueryClientProvider>
				</HelmetProvider>
			</PostHogProvider>
		</div>
	);
}

export default App;
